import { FC } from 'react';
import { removeHtmlTagsFromString } from '../../../utils/StringUtils';
import { cn } from '../../../utils/classUtils';

interface AgentConfigDrivenTitleProps {
  title: string;
  textStyle?: string;
}

const AgentConfigDrivenTitle: FC<AgentConfigDrivenTitleProps> = ({
  title,
  textStyle,
}) => {
  const processedTitle = removeHtmlTagsFromString(title).replace(/\\n/g, '\n');

  return (
    <div
      className={cn(
        'font-inter font-semibold text-2xl text-reskin-primary-navy whitespace-pre-line',
        textStyle,
      )}
    >
      {processedTitle}
    </div>
  );
};

export default AgentConfigDrivenTitle;
